var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 59,
    viewBox: "0 0 49 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2327 6.98863C22.182 3.79623 26.818 3.79624 28.7674 6.98864L41.0735 27.1424C43.1079 30.4742 40.71 34.748 36.8061 34.748H12.1939C8.29003 34.748 5.89207 30.4742 7.92652 27.1423L20.2327 6.98863Z",
    fill: "#FDDC2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7627 25.8053V15.4453H26.1427V25.8053H23.7627ZM23.7627 29.8453V27.4653H26.1427V29.8453H23.7627Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarn);
export default __webpack_public_path__ + "static/media/icon-warn.7ffc173fadb4c436daa7062402452d9b.svg";
export { ForwardRef as ReactComponent };